import styled from "@emotion/styled"

export const Grow = styled.div`
  flex-grow: 1;
  justify-content: initial;
  align-items: initial;
`

export default Grow
